// «Скрыть e-mail» при входе через Apple выдаёт адрес-ретранслятор вида
// 48pb5fndbf@privaterelay.appleid.com. Он рабочий — письма доходят через
// пересылку Apple, — но в профиле выглядит техническим мусором и пугает.
// Вместо адреса показываем способ входа, как принято у Spotify и Notion:
// «Почта скрыта (вход через Apple)» читалось как сообщение об ошибке.
// Пустую строку не отдаём — она превращается в «Без email», а это выглядит
// как дефект аккаунта. Сам адрес остаётся в аккаунте, сервер шлёт письма
// на него как обычно.

export function isHiddenAppleEmail(email) {
  return typeof email === 'string' && email.endsWith('@privaterelay.appleid.com')
}

export function displayEmail(email) {
  if (!email) return email
  return isHiddenAppleEmail(email) ? 'Вход через Apple' : email
}
